import React, { useState } from "react";
import './style.scss';
// import config from "../../config";
import client from '../../clients';
import SearchFilter from "../search-filter";

const BrandFilter = () => {

  const [isBrandListOpen, setBrandListOpen] = useState(false); 
  const [selectedBrand, setSelectedBrand] = useState(
    {name: "Muscle Blaze"}
  );
  const [brandsList, setBrandList] = useState([
    {name: "Muscle Blaze"},
    {name: "Man Matters"},
    {name: "Optimum Nutrition (ON)"},
    {name: "MyProtein"},
    {name: "HealthKart"},
    {name: "GNC"},
    {name: "Fast&Up"},
    {name: "Beardo"},
    {name: "The Man Company"},
    {name: "Ustraa"},
    {name: "Traya"},
    {name: "Pilgrim"}
  ])

  const toggleBrandList = () => {
    setBrandListOpen(!isBrandListOpen);
  }

  const handleSearchingData = (searchingData) => {
    console.log(searchingData);
  }
  
  const handleSelectBrand = (brand) => {
    setSelectedBrand(brand);
    toggleBrandList();
  }

  return(
    <div className="select-brand-container flex-item d-flex cursor-pointer">
      {
        window.innerWidth < 768 ? (
          <div onClick={toggleBrandList} className="d-flex w-full">
            <div className="flex-item d-flex margin-auto">
              <p className="flex-item m-r-4 font-weight-700 color-dark-blue fs-16">{selectedBrand && selectedBrand.name ? selectedBrand.name.length > 16 ?  selectedBrand.name.slice(0, 16) + "..." : selectedBrand.name : "Select Brand"}</p>
              <svg className="flex-item" style={{transition:"180ms", transform: isBrandListOpen ? "rotate(180deg)" : "rotate(0deg)"}} width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.04883 10L12.0488 15L17.0488 10" stroke="#6D6D6D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        ) : (
          <div onClick={toggleBrandList} className="d-flex">
            <div className="d-flex m-r-30">
              {
                selectedBrand.logoFileID ? (
                  <img className="brand-logo flex-item m-r-8" src={`${client.config.API_URL}/image/file/${selectedBrand.logoFileID}/auto/auto/70`} loading='lazy' />
                ) : (
                  <div className="brand-no-logo m-r-8 flex-item d-flex">
                    <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14}}>{`${selectedBrand.name}`.trim()[0]}</p>
                  </div>
                ) 
              }
              <p className="flex-item fs-18 font-weight-700" style={{lineHeight:"18px"}}>{selectedBrand.name}</p>
            </div>
            <div className="table-action-button d-flex" style={{backgroundColor: isBrandListOpen ? "#720B0B" : "#ffffff", minWidth:"30px", maxWidth:"30px"}}>
              <svg className="flex-item svg-stroke margin-auto" style={{transition:"180ms", transform: isBrandListOpen ? "rotate(180deg)" : "rotate(0deg)"}} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.5 0.5L7 7.5L13.5 0.5" stroke={isBrandListOpen ? "#ffffff" : "#9A9A9A"} stroke-linecap="round"/>
              </svg>
            </div>
          </div>
        )
      }

      {
        isBrandListOpen && [
          <div className="w-full brand-list-container slideTopToBottom">
            {
              window.innerWidth < 768 && (
                <div className="w-full selected-brand-list-container d-flex space-between">
                  {
                    selectedBrand ? (
                      <div className="brand-selected-container w-full d-flex">
                        {
                          selectedBrand.logoFileID ? (
                            <div className='selected-brand-logo flex-item m-r-12'>
                              <img src={`${client.config.API_URL}/image/file/${selectedBrand.logoFileID}/auto/auto/70`} loading='lazy' />
                            </div>
                          ) : (
                            <div className="brand-no-logo m-r-12 flex-item d-flex">
                              <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14}}>{`${selectedBrand.name}`.trim()[0]}</p>
                            </div>
                          ) 
                        }
                        <p className="w-full flex-item m-r-4 font-weight-700 color-dark-blue fs-16" style={{width:"60%"}}>{selectedBrand && selectedBrand.name.length > 0 ? selectedBrand.name.length > 22 ?  selectedBrand.name.slice(0, 22) + "..." : selectedBrand.name : "NULL"}</p>        
                      </div>
                    ) : (
                      <p className="selected-brand-name flex-item m-r-4 font-weight-700 color-dark-blue fs-20">Select Brand</p>        
                    )
                  }
                  <div onClick={toggleBrandList} className="table-action-button d-flex" style={{backgroundColor: isBrandListOpen ? "#720B0B" : "#ffffff"}}>
                    <svg className="flex-item svg-stroke margin-auto" style={{transition:"180ms", transform: isBrandListOpen ? "rotate(180deg)" : "rotate(0deg)"}} width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.5 0.5L7 7.5L13.5 0.5" stroke={isBrandListOpen ? "#ffffff" : "#9A9A9A"} stroke-linecap="round"/>
                    </svg>
                  </div>
                </div>
              )
            }

            <div className={`w-full ${window.innerWidth > 767 && "p-t-12 p-l-12"}`}>
              <SearchFilter searchType={"Brand Name"} filterSection="brand-filter" isSearchEnabled={true} SearchingData={handleSearchingData} isFilterEnabled={false} searchFieldWidth={window.innerWidth > 767 ? 240 : ""}/>
            </div>
            <div className={`brand-list ${window.innerWidth > 767 && "m-t-16"}`} style={{height: window.innerWidth < 768 && selectedBrand != null  ? "75%" : ""}} >
              {
                brandsList.map(data => {
                  return(
                    <div onClick={()=>handleSelectBrand(data)} className="d-flex cursor-pointer brand-list-item cursor-pointer">
                      {
                        data.logoFileID ? (
                          <div className='brand-list-logo flex-item m-r-12'>
                            <img id="brand-ImgWrapper" src={`${client.config.API_URL}/image/file/${data.logoFileID}/auto/auto/70`} loading='lazy' />
                          </div>
                        ) : (
                          <div className="brand-no-logo m-r-12 flex-item d-flex" style={{backgroundColor: "#5d883c"}}>
                            <p className='flex-item' style={{color: "#ffffff", margin: "0 auto", fontSize: 14}}>{`${data.name}`.trim()[0]}</p>
                          </div>
                        ) 
                      }
                      <p className="font-weight-700 fs-16 color-dark-blue flex-item" style={{lineHeight:"16px"}}>{data.name}</p>
                    </div>
                  )
                })
              }
            </div>
          </div>,
           window.innerWidth < 768 && (
            <div onClick={toggleBrandList} className="modal-bg-blur" style={{zIndex: 8}}/>
          )
        ]
      }
    </div>
  )
}

export default BrandFilter;